import { TURNSTILE_SITE_KEY } from "~/lib/constants";

export function getTurnstileSiteKey(): string {
  return TURNSTILE_SITE_KEY ?? "";
}

export function isTurnstileConfigured(): boolean {
  return getTurnstileSiteKey() !== "";
}
